import { CaseTypeDocumentTemplateModel } from '../caseTypeDocumentTemplate/caseTypeDocumentTemplateModel';
import { DocumentTemplateModel } from './documentTemplateModel';

export class AddDocumentTemplateModel extends DocumentTemplateModel{
    public caseTypeDocumentTemplates: CaseTypeDocumentTemplateModel[];
    public templateFile: File;
}
